
const imageUrl = (title) => {
  return `/imgs/dc/${title}.png`;
};

const banner = {
  title: '数据中心',
  description: '基于业务驱动的云数据中心，高效、清晰、实时、安全，持续为客户创造价值；实时监控日运营、月运营数据；便于各个层级分析决策。',
  img: imageUrl('banner')
};

const feature = [
  {
    title: '数据源轻松整合',
    items: [
      '同一个大屏看板轻松整合各类管理系统、生产系统的数据，打破信息孤岛，进行综合展示分析，让决策更清晰。',
    ]
  },
  {
    title: '海量可视化图表',
    items: [
      '数十种可视化图标效果，满足不同人群的查阅偏好，为展示多样数据信息提供全面支持。',
    ]
  },
  {
    title: '自适应多屏展示',
    items: [
      '设计模板可在手机、平板、PC、大屏等多种设备上自适应展示，可随时随地掌握企业相关数据。',
    ]
  },
  {
    title: '数据挖掘联动分析',
    items: [
      '支持业务互动，包括多层级的挖掘、多维度的联动分析，配合其他组件可更好的发现并分析业务问题。',
    ]
  }
];

const func = [
  {
    title: '商业智能BI',
    img: imageUrl('func1'),
    description: '高度可定制化BI，可实现任意的数据交互和自由探索'
  },
  {
    title: '报表统计',
    img: imageUrl('func2'),
    description: '可按需设计各类企业报表，完全满足生产需要'
  },
  {
    title: '整合数据',
    img: imageUrl('func3'),
    description: '丰富的接口连接内部、云端和文件等数据，为报表统计和BI分析提供完整数据支撑'
  },
  {
    title: '数据大屏',
    img: imageUrl('func4'),
    description: '为内部共享、数据监控和行业交流，提供最形象的数据呈现方式'
  },
];

const structure = imageUrl('structure');

export {banner, feature, func, structure};


// WEBPACK FOOTER //
// ./src/routes/ProductDC/config.js